<template>
  <div class="row-col">
    <p class="universal-balance-count">
      <strong>
        <number id="zoom-count-popover"
          ref="zoomBal"
          :from="fromZoomBalance"
          :to="toZoomBalance"
          :format="formatNumber"
          :duration="3.5"
        />
        ZOOM {{ " " }}
        tokens
      </strong>
      {{ " " }}in ZWorld
    </p>
    <p class="universal-balance-count">
      <strong>
        <number id="nfts-count-popover"
          ref="nftSupply"
          :from="fromNftSupply"
          :to="toNftSupply"
          :format="formatNumber"
          :duration="3.5"
        />
        NFTs
      </strong>
      in ZWorld
    </p>
    <p class="universal-balance-count" style="padding-right: 10px;">
      <strong>
        <number id="card-types-popover"
          ref="nftTypes"
          :from="fromNftTypes"
          :to="toNftTypes"
          :format="formatNumber"
          :duration="3.5"
        />
        Mintable types
      </strong>
      in shop and boosters
    </p>
    <b-popover :show="getURLFolder() == 'shop' && Progression.stepIndex==2 && Progression.storyIndex==1" target="card-types-popover" triggers="manual" placement="bottom" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.shop[2].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="getURLFolder() == 'shop' && Progression.stepIndex==2 && Progression.storyIndex==3" target="nfts-count-popover" triggers="manual" placement="bottom" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.shop[2].popovers[3].content }}
      </div>
    </b-popover>
    <b-popover :show="getURLFolder() == 'shop' && Progression.stepIndex==2 && Progression.storyIndex==4" target="zoom-count-popover" triggers="manual" placement="bottom" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.shop[2].popovers[4].content }}
      </div>
    </b-popover>
    <b-popover :show="getURLFolder() == 'card-sets' && Progression.stepIndex==1 && Progression.storyIndex==1" target="card-types-popover" triggers="manual" placement="bottom" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.cardSets[1].popovers[1].content }}
      </div>
    </b-popover>
  </div>
</template>
<script>
import { BButton, BPopover } from "bootstrap-vue";
import { mapGetters } from "vuex";
import storyInstructions from "./story-instructions.json";
import { Progression } from './Progression.js'

export default {
  name: "UniverseBalances",
  props: {
    isInOwnCrypt: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      storyInstructions,
      Progression,
      newZoomBalance: null,
      prevZoomBalance: null,
      newNftTypes: null,
      prevNftTypes: null,
      newNftSupply: null,
      prevNftSupply: null,
    };
  },
  components: {
    BPopover,
  },
  methods: {
    getURLFolder() {
      return window.location.pathname.split("/")[2];
    },
    formatNumber(number) {
      return parseInt(number.toFixed(0)).toLocaleString();
    },
    pulsateText(ref) {
      ref.$el.classList.value = ref.$el.classList.value + "pulsate";
      ref.play();
      setTimeout(() => {
        ref.$el.classList.value = "";
      }, 500);
    },
  },
  computed: {
    fromZoomBalance() {
      return this.prevZoomBalance || this.getTotalZoomBalance;
    },
    toZoomBalance() {
      return this.newZoomBalance || this.getTotalZoomBalance;
    },
    fromNftSupply() {
      return this.prevNftSupply || this.getTotalNftSupply;
    },
    toNftSupply() {
      return this.newNftSupply || this.getTotalNftSupply;
    },
    fromNftTypes() {
      return this.prevNftTypes || this.getTotalNftTypes;
    },
    toNftTypes() {
      return this.newNftTypes || this.getTotalNftTypes;
    },
    ...mapGetters({
      getTotalZoomBalance: "blockChain/getTotalZoomBalance",
      getTotalNftSupply: "blockChain/getTotalNftSupply",
      getTotalNftTypes: "blockChain/getTotalNftTypes",
    }),
  },
  watch: {
    getTotalZoomBalance(newVal, oldVal) {
      this.newZoomBalance = newVal;
      this.prevZoomBalance = oldVal;
      if (oldVal > 0) {
        this.pulsateText(this.$refs.zoomBal);
      }
    },
    getTotalNftSupply(newVal, oldVal) {
      this.newNftSupply = newVal;
      this.prevNftSupply = oldVal;
      if (oldVal > 0) {
        this.pulsateText(this.$refs.nftSupply);
      }
    },
    getTotalNftTypes(newVal, oldVal) {
      this.newNftTypes = newVal;
      this.prevNftTypes = oldVal;
      if (oldVal > 0) {
        this.pulsateText(this.$refs.nftTypes);
      }
    },
  },
};
</script>
<style scoped>
p {
  padding-left: 10px;
  margin-bottom: 0;
}

.universal-balance-count {
  font-family: "Truculenta", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #DC78FF;
}

.btn {
  margin-right: 5px;
}

.czxp-logo {
  width: 20px;
  height: 20px;
  margin-right: 2px;
}

.row-col {
  display: flex;
  flex-direction: column;

  margin: 20px 0;
}

@media screen and (min-width: 600px) {
  .row-col {
    flex-direction: row;
    justify-content: space-between;
  }
}

.pulsate {
  display: inline-block;
  transform: scale(1);
  animation: pulsate 0.5s ease-out;
}

@keyframes pulsate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
